module.exports = __webpack_public_path__ + "static/image1-106166d008af0a7051e648e6e02aa7d5.jpg";